import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useRouter } from '~/utils/navigation';
import { LabelBold } from '@comeon/ui';
import IconButtonClose from '../../../misc/icon-button-close.js';
import { ROUTE_WE_SPIN_LOBBY } from '../constants/we-spin-route-constants.js';
import { selectDefaultEventForSession } from '../ducks/we-spin-selectors.js';
import { ENDED } from '../constants/we-spin-stream-states.js';

const WeSpinDesktopGameViewHeader = () => {
	const router = useRouter();
	const { ref } = useParams();
	const { streamerName = '', currentGame = '', state = ENDED } = useSelector(selectDefaultEventForSession(ref)) || {};

	const onButtonClose = useCallback(() => router.push(ROUTE_WE_SPIN_LOBBY), [router]);

	return (
		<div className="game-view u-pl1 u-pb1">
			<header className="u-flex u-align-vert">
				<div className="u-pt1 u-pb1 u-pr1 we-spin-game-view-header-icon">
					<IconButtonClose onClick={onButtonClose} />
				</div>
				{state !== ENDED && (
					<div className="u-p1 we-spin-game-view-header-title">
						<LabelBold>
							{streamerName} - {currentGame.gameName}
						</LabelBold>
					</div>
				)}
			</header>
		</div>
	);
};

export default WeSpinDesktopGameViewHeader;
